import config from '@plone/volto/registry';
import HeadTitle from '@package/components/HeadTitle';

const View = ({ properties, metadata, data }) => {
  const content = (metadata || properties)['head_title'] || '';

  if (!content) return null;

  const show_alignment = !config.blocks?.blocksConfig?.subject?.hide_alignment;

  return (
    <HeadTitle
      content={content}
      align={show_alignment ? data.alignment : null}
    />
  );
};

export default View;
